import { Injectable } from '@angular/core';
import { ArrayFunctions } from '@campus/utils';
import { Observable } from 'rxjs';
import { LearningPlanInterface } from '../../+models';
import { InkApi, ModelInkApiBase } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningPlanInkApi extends ModelInkApiBase {
  constructor(api: InkApi) {
    super(api, 'learning-plan');
  }

  getForPublication(publicationIds: number | number[]): Observable<LearningPlanInterface[]> {
    const ids = ArrayFunctions.wrapIntoArray(publicationIds);
    const params = this._getHttpParams({ bookIds: ids.join(',') });
    return this.get<LearningPlanInterface[]>('for-book', params);
  }

  search(
    searchTerm?: string,
    filters?: { [key: string]: string | number | number[] },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningPlanInterface[]; count: number }> {
    const params = this._getHttpParams({
      searchTerm: searchTerm || '',
      filters: filters || {},
      columns: columns || [],
      sorting: sorting || {},
      pagination: pagination || {},
    });
    return this.get<{ results: LearningPlanInterface[]; count: number }>('', params);
  }
}
